import axios, { AxiosPromise } from 'axios';
import AuthService from './AuthService';
import { BaseService } from './BaseService';
import { SchoolVerificationState } from './SchoolService';

class SchoolVerificationService extends BaseService {
    constructor() {
        super('identity/university/connection', true);
    }

    async updateState(schoolId: number, newState: SchoolVerificationState) {
        return axios({
            method: 'PATCH',
            url: this.getUrl(''),
            data: {
                schoolId,
                state: newState,
            },
        });
    }

    async delete(schoolId: number) {
        return axios({
            method: 'DELETE',
            url: this.getUrl(''),
            params: {
                userId: await AuthService.getUserId(),
                schoolId,
            },
        });
    }
}

export default SchoolVerificationService;
